<template>
  <div>
    <!-- nav区 -->
    <div>
      <nav-bar title="资讯详情" rightText="首页"></nav-bar>
    </div>
    <div class="content w">
      <div class="title">{{ newsDetail.catName }}</div>
      <div v-html="newsDetail.nInfo"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navActive: '',

      newsId: '',
      newsDetail: ''
    }
  },
  created() {
    var query = this.$route.query
    if (query.newsId) {
      this.newsId = query.newsId
    }
    this.getNewsDetail()
  },
  methods: {
    async getNewsDetail() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/news/newsDetail?newsId=' + this.newsId)
      if (data.success) {
        this.newsDetail = data.data.carsInfo
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 10px 5%;
  background-color: #fafafa;
  overflow: hidden;
}
.title {
  background-color: #f2f2f2;
  line-height: 2;
  text-indent: 1em;
  font-size: 18px;
}
</style>
